<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import Loading from '@/components/Loading.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import validationFormMixin from '@/mixins/validation.mixin'
import http from '@/utils/http'

const latitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(90(\.0{0,6})?|[1-8]?\d(\.\d{0,6})?)$/.test(value.toString())
}

const longitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(180(\.0{0,6})?|([1-9]|1[0-7])?\d(\.\d{0,6})?)$/.test(
    value.toString()
  )
}

export default {
  name: 'EtaForm',
  components: { Loading },
  mixins: [validationMixin, validationFormMixin],
  data: () => {
    return {
      active: false,
      etaId: null,
      localId: null,
      form: {
        nome: '',
        nomeCaptacao: '',
        uf: 'MT',
        municipio: '',
        nomeSaa: '',
        codigoSaa: '',
        responsavelSaa: '',
        responsavelDados: '',
        cargoResponsavel: '',
        latitude: null,
        longitude: null,
        template: null,
      },
      loading: false,
      downloadTemplateLoading: false,
      templates: [],
      cidades: [],
      estados: [
        'AC',
        'AL',
        'AM',
        'AP',
        'BH',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MG',
        'MS',
        'MT',
        'PA',
        'PB',
        'PE',
        'PI',
        'PR',
        'RJ',
        'RN',
        'RO',
        'RR',
        'RS',
        'SC',
        'SE',
        'SP',
        'TO',
      ],
    }
  },
  validations: {
    form: {
      nome: {
        required,
      },
      nomeCaptacao: {
        required,
      },
      uf: {
        required,
      },
      municipio: {
        required,
      },
      nomeSaa: {
        required,
      },
      codigoSaa: {},
      responsavelSaa: {
        required,
      },
      responsavelDados: {
        required,
      },
      cargoResponsavel: {
        required,
      },
      latitude: {
        required,
        latitudeValidation,
      },
      longitude: {
        required,
        longitudeValidation,
      },
      template: {
        required,
      },
    },
  },
  async beforeMount() {
    this.localId = this.$route.params.localId

    await this.buscaTemplates()

    if (this.$route.params.etaId) {
      this.etaId = this.$route.params.etaId
      this.buscarEta()
    }

    this.buscaEstado(this.form.uf)
  },
  methods: {
    async buscaTemplates() {
      const data = await http.eta.get('eta/template')
      this.templates = data || []
    },
    async buscaEstado(sigla) {
      this.form.municipio = ''

      const data = await http.get(`cidade/${sigla}`)
      this.cidades = data.cidades || []
    },
    async salvarEta() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      if (this.etaId) {
        await http.eta
          .put(
            'eta/' + this.etaId,
            {
              ...this.form,
              localId: this.localId,
            },
            false
          )
          .then(() => {
            EventBus.$emit(Topics.NOTIFICATIONS, {
              message: 'ETA salva com sucesso',
              type: Types.INFO,
            })
          })
          .catch(() => {
            EventBus.$emit(Topics.NOTIFICATIONS, {
              message: 'Erro ao salvar ETA',
              type: Types.DANGER,
            })
          })
      } else {
        await http.eta
          .post(
            'eta',
            {
              ...this.form,
              localId: this.localId,
            },
            false
          )
          .then((data) => {
            this.etaId = data.id
            EventBus.$emit(Topics.NOTIFICATIONS, {
              message: 'ETA salva com sucesso',
              type: Types.INFO,
            })
          })
          .catch(() => {
            EventBus.$emit(Topics.NOTIFICATIONS, {
              message: 'Erro ao salvar ETA',
              type: Types.DANGER,
            })
          })
      }
    },
    buscarEta() {
      this.loading = true

      http.eta
        .get(`eta/${this.etaId}`)
        .then((data) => {
          this.form = data
        })
        .catch(() => {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Erro ao buscar ETA',
            type: Types.DANGER,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async downloadTemplate(template) {
      if (template === null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          message: 'Selecione um template',
          type: Types.WARNING,
        })
        return
      }

      this.downloadTemplateLoading = true
      await http.eta
        .getDownload(`eta/template/download/${template}`, {})
        .then((e) => {
          const blob = e.data
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${template}.docx`
          link.click()
        })
        .catch(() => {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Erro ao baixar template',
            type: Types.DANGER,
          })
        })
        .finally(() => {
          this.downloadTemplateLoading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <div class="row" style="align-items: baseline">
      <div class="hover-cursor ml-2" @click="active = true">
        <md-icon class=""> arrow_back </md-icon>
      </div>
      <div class="ml-3">
        <h1 class="md-title">{{ etaId === null ? 'NOVA' : 'EDITAR' }} ETA</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <md-steppers md-linear class="remove-box">
          <md-step md-label="Cadastro ETA" :md-editable="false" />

          <md-step
            md-label="Pontos de coleta"
            :md-editable="false"
            :md-done="false"
          />
        </md-steppers>
      </div>
    </div>

    <div v-if="loading" style="text-align: center">
      <md-progress-spinner
        :md-diameter="500"
        :md-stroke="15"
        md-mode="indeterminate"
      />
    </div>

    <div v-if="!loading" class="row ml-2">
      <div class="col-6">
        <md-field :class="getValidationClass('nome')">
          <label for="nome">Nome</label>
          <md-input id="nome" v-model="form.nome" />
          <span v-if="!$v.form.nome.required" class="md-error"
            >Nome é obrigatório</span
          >
        </md-field>

        <md-field :class="getValidationClass('nomeCaptacao')">
          <label for="nomeCaptacao">Nome de captação</label>
          <md-input id="nomeCaptacao" v-model="form.nomeCaptacao" />
          <span v-if="!$v.form.nomeCaptacao.required" class="md-error"
            >Nome de captação é obrigatório</span
          >
        </md-field>

        <div class="row">
          <div class="col-8">
            <md-field :class="getValidationClass('template')">
              <label for="template">Template</label>
              <md-select v-model="form.template">
                <md-option
                  v-for="template in templates"
                  :key="template"
                  :value="template"
                >
                  {{ template }}
                </md-option>
              </md-select>
              <span v-if="!$v.form.template.required" class="md-error"
                >Template é Obrigatório</span
              >
            </md-field>
          </div>
          <div class="col-3">
            <md-button
              class="md-raised md-primary"
              @click="() => downloadTemplate(form.template)"
            >
              Download template
            </md-button>
          </div>
          <div v-if="downloadTemplateLoading" class="col-1">
            <md-progress-spinner
              :md-diameter="40"
              :md-stroke="5"
              md-mode="indeterminate"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <md-field :class="getValidationClass('uf')">
              <label for="uf">UF</label>
              <md-select v-model="form.uf" @md-selected="buscaEstado">
                <md-option
                  v-for="estado in estados"
                  :key="estado"
                  :value="estado"
                >
                  {{ estado }}
                </md-option>
              </md-select>
              <span v-if="!$v.form.uf.required" class="md-error"
                >Estado é obrigatório</span
              >
            </md-field>
          </div>

          <div class="col">
            <md-field :class="getValidationClass('municipio')">
              <label for="municipio">Município</label>
              <md-select v-model="form.municipio">
                <md-option
                  v-for="cidade in cidades"
                  :key="cidade.id"
                  :value="cidade.nome"
                >
                  {{ cidade.nome }}
                </md-option>
              </md-select>
              <span v-if="!$v.form.municipio.required" class="md-error"
                >Município é Obrigatório</span
              >
            </md-field>
          </div>
        </div>

        <md-field :class="getValidationClass('nomeSaa')">
          <label for="nomeSaa">Nome SAA</label>
          <md-input id="nomeSaa" v-model="form.nomeSaa" />
          <span v-if="!$v.form.nomeSaa.required" class="md-error"
            >Nome SAA é obrigatório</span
          >
        </md-field>

        <md-field :class="getValidationClass('codigoSaa')">
          <label for="codigoSaa">Código SAA</label>
          <md-input id="codigoSaa" v-model="form.codigoSaa" />
        </md-field>

        <md-field :class="getValidationClass('responsavelSaa')">
          <label for="responsavelSaa">Instituição responsável</label>
          <md-input id="responsavelSaa" v-model="form.responsavelSaa" />
          <span v-if="!$v.form.responsavelSaa.required" class="md-error"
            >Responsável SAA é obrigatório</span
          >
        </md-field>

        <md-field :class="getValidationClass('responsavelDados')">
          <label for="responsavelDados">Responsável Dados</label>
          <md-input id="responsavelDados" v-model="form.responsavelDados" />
          <span v-if="!$v.form.responsavelDados.required" class="md-error"
            >Responsável Dados é obrigatório</span
          >
        </md-field>

        <md-field :class="getValidationClass('cargoResponsavel')">
          <label for="cargoResponsavel">Cargo Responsável</label>
          <md-input id="cargoResponsavel" v-model="form.cargoResponsavel" />
          <span v-if="!$v.form.cargoResponsavel.required" class="md-error"
            >Cargo Responsável é obrigatório</span
          >
        </md-field>

        <div class="row">
          <div class="col-6">
            <md-field :class="getValidationClass('latitude')">
              <label for="latitude">Latitude (graus decimais)</label>
              <md-input
                id="latitude"
                v-model.number="form.latitude"
                v-coordinate-decimals
                name="latitude"
                type="number"
                step="0.000001"
              />
              <span v-if="!$v.form.latitude.required" class="md-error">
                Latitude é obrigatória
              </span>
              <span
                v-if="!$v.form.latitude.latitudeValidation"
                class="md-error"
              >
                Latitude inválida
              </span>
            </md-field>
          </div>
          <div class="col-6">
            <md-field :class="getValidationClass('longitude')">
              <label for="longitude">Longitude (graus decimais)</label>
              <md-input
                id="longitude"
                v-model.number="form.longitude"
                v-coordinate-decimals
                name="longitude"
                type="number"
                step="0.000001"
              />
              <span v-if="!$v.form.longitude.required" class="md-error">
                Longitude é obrigatória
              </span>
              <span
                v-if="!$v.form.longitude.longitudeValidation"
                class="md-error"
              >
                Longitude inválida
              </span>
            </md-field>
          </div>
        </div>

        <div class="row" style="text-align: right">
          <div class="col-12">
            <md-button
              class=""
              @click="$router.push({ name: 'EtaIndex', params: $route.params })"
            >
              Cancelar
            </md-button>
            <md-button class="md-raised md-primary" @click="() => salvarEta()">
              SALVAR ETA
            </md-button>

            <md-button
              :disabled="etaId === null"
              class="md-raised md-primary"
              @click="
                $router.push({
                  name: 'EtaPontos',
                  params: { ...$route.params, etaId: etaId },
                })
              "
            >
              Próximo passo
            </md-button>
          </div>
        </div>
      </div>
    </div>

    <md-dialog-confirm
      :md-active.sync="active"
      :md-title="etaId === null ? 'Cancelar cadastro' : 'Cancelar edição'"
      :md-content="
        etaId === null
          ? 'Você está prestes a cancelar o cadastro da ETA. Essa ação é irreversível. Deseja realmente desistir?'
          : 'Deseja realmente cancelar a edição da ETA?'
      "
      :md-confirm-text="etaId === null ? 'Cancelar cadastro' : 'Voltar'"
      :md-cancel-text="etaId === null ? 'Continuar cadastro' : 'Cancelar'"
      @md-cancel="active = false"
      @md-confirm="$router.push({ name: 'EtaIndex', params: $route.params })"
    />
  </div>
</template>

<style lang="scss">
.remove-box > .md-steppers-navigation {
  box-shadow: 0 0 !important;
}

.hover-cursor:hover {
  cursor: pointer;
}
</style>
